import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsCreatorSettings } from '@/learnpaths-creator/components/LearnpathsCreatorSettings/LearnpathsCreatorSettings'
import LearnpathsAddElementsRedirect from '@/learnpaths/components/LearnpathsAddElementsRedirect/LearnpathsAddElementsRedirect'
import { useManagedLearnpath } from '@/learnpaths/queries/useManagedLearnpath'

export const Route = createFileRoute(
  '/company/learnpaths/add/completion-time/$learnpathId',
)({
  component: LearnpathsAddCompletionTime,
})

function LearnpathsAddCompletionTime() {
  const { learnpathId } = Route.useParams()
  const { data } = useManagedLearnpath({ learnpathId })

  if (data?.is_course) {
    return null
  }

  return (
    <LearnpathsAddElementsRedirect>
      <LearnpathsCreatorSettings />
    </LearnpathsAddElementsRedirect>
  )
}
